<template>
  <div class="checkout-view" :class="{isLoading}">
    <FloatingHeader
      title="Checkout"
      sbtitle="Pagamento"
      :showHeader="true"
      :hideSearch="true"
      :toClear="'updateCurrentItemEdit'"
      :routeToBack="'cart'">
    </FloatingHeader>

    <div class="payment-container" v-if="getCart && getCart?.length">
      <div class="payment-options">
        <div class="payment-options-list">
          <div class="payment-option" v-for="option in paymentOptions" :key="option.id"
            @click="handlePaymentOption(option)"
            :class="{ active: activePaymentOption === option.id, isCard: option.id === 1, isPix: option.id === 2, disabled: option.disabled }">
            <div class="payment-option-icon" :class="option.icon.name">
              <fa :icon="[option.icon.type, option.icon.name]" />
            </div>
            <div class="payment-option-name">
              <span>{{ option.name }}</span>
            </div>
          </div>
        </div>

        <div class="credit-card" v-if="activePaymentOption === 1">
          <div class="cards-list" v-if="userCardList.length > 0">
            <h1>
              Selecione um cartão cadastrado
            </h1>
            <div class="list-fields">
              <span v-for="(field, key) in listFields" :key="key" v-text="field"></span>
            </div>

            <div class="card-item-wrapper" :class="{ selected: selectedCard == card }" v-for="(card, key) in userCardList" :key="key">
              <div class="card-item" @click="selectCard(card)" :class="{ selected: selectedCard == card }">
                <div v-for="(cardDet, cdetkey) in ['number', 'name', 'expiration', 'flag']" :key="cdetkey">
                  <span :class="cardDet" v-if="cardDet == 'expiration'" v-text="getExpirationAsDate(card[cardDet])"></span>
                  <span :class="cardDet" v-else-if="cardDet == 'number'" v-text="card[cardDet]"></span>
                  <img :class="cardDet" v-else-if="cardDet == 'flag'" :src="getCardFlag(card[cardDet])" />
                  <span :class="cardDet" v-else v-text="card[cardDet]"></span>
                </div>
              </div>

              <transition name="fade-slide">
                <button v-if="selectedCard === card" class="delete-button" @click.stop="deleteCard(card)">
                  <fa icon="trash" />
                </button>
              </transition>
            </div>
          </div>

          <div class="not-found" v-else>
            <h1>Você não possui nenhum meio de pagamento cadastrado.</h1>
            <h1 v-if="!this.isFullApp">Cadastre seu cartão para continuar, ou pague via Pix.</h1>
          </div>

          <div class="add-card">
            <DefaultButton :text="'Adicionar Cartão'"
              @defaultBtnClick="changeCardAdditionMenuVisibility()" :large="false">
            </DefaultButton>
          </div>
        </div>

        <div class="pix" v-if="activePaymentOption === 2">
          <div class="pix-container">
            <div class="loading" v-if="loadingQrCode">
              <h2>Gerando QRCode</h2>
              <fa icon="spinner" spin size="lg" />
            </div>
            <div class="qrcode" v-else-if="qrCodeText">
              <h2 class="opened-payment" v-if="openedPayment">
                Você já possui um pagamento em aberto. Aguarde a confirmação do pagamento ou tente novamente mais tarde.
                Abaixo está o código do pagamento em aberto.
              </h2>
              <div class="container">
                <VueQRCodeComponent :text="qrCodeText" />
              </div>

              <div class="copy-pix" v-if="!loadingQrCode && !error">
                <input type="text" readonly :value="qrCodeText" ref="pixCodeInput" />
                <!-- <button @click="copyPixCode">Copiar código</button> -->
              </div>

              <h3 v-if="!error" class="finish-payment-warning">
                Finalize o pagamento pelo aplicativo do seu banco. O código é válido por {{ formatMilliseconds(pixTimeout) }}.
              </h3>
            </div>
            <h2 class="opened-payment" v-else-if="openedPayment">
              Você já possui um pagamento em aberto. Aguarde a confirmação do pagamento ou tente novamente mais tarde.
            </h2>
            <h2 class="error" v-else-if="error">
              Ocorreu um erro ao gerar o código Pix. Tente novamente mais tarde ou finalize o pagamento com seu cartão.
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="checkout" v-if="getCart && getCart?.length">
      <div class="total-price">
        <h2>Total</h2>
        <span>{{ formatMoney(totalValue) }}</span>
      </div>

      <!-- <GooglePayButton v-if="activePaymentOption === 1" :totalValue="totalValue" @gpayConfirm="handleGpayConfirmation" /> -->

      <div class="custom-default-button">
        <DefaultButton :text="this.paymentButtonText || (this.activePaymentOption === 1 ? 'Pagar' : 'Copiar Código Pix')"
          :disabled="isDisabledCheckout()"
          @defaultBtnClick="handleConfirmation()" :large="true"
          v-if="getCart && getCart?.length && ((!loadingQrCode && !error) || activePaymentOption === 1)">
        </DefaultButton>
      </div>
    </div>

    <CardAdditionComponent @addCard="addCard" v-if="cardAdditionMenu.isVisible" />
    <ScreenLoader :isLoading="isLoading" />

    <ModalInfo @actionTrue="confirmDeleteCard" @actionFalse="closeModalInfo">
    </ModalInfo>

  </div>
</template>
<script>
import FloatingHeader from '@/components/FloatingHeader.vue'
import { mapActions, mapGetters } from 'vuex'
import Util from '@/assets/libs/util'
import CartController from '@/assets/controllers/CartController'
import DefaultButton from '@/components/buttons/DefaultButton.vue'
import moment from 'moment'
import CardAdditionComponent from '@/components/bottom-popups/CardAdditionComponent.vue'
import VueQRCodeComponent from 'vue-qrcode-component'
import { getUserCards, registerNewCard, deleteCreditCard } from '@/assets/controllers/CardsController'
import { doCardTokenPayment, doFinishSale, doPixPayment, getPixPaymentStatus, doGooglePayPayment, sendEmailConfirmation } from '@/assets/controllers/PaymentController'
import { loadSingleEvent } from '@/assets/controllers/EventController'
import ScreenLoader from '@/components/loader/ScreenLoader.vue'
import ModalInfo from '@/components/modals/ModalInfo.vue'
// import GooglePayButton from '@/components/google-pay/GooglePayButton.vue'

export default {
  name: 'CheckoutView',
  components: {
    FloatingHeader,
    DefaultButton,
    CardAdditionComponent,
    VueQRCodeComponent,
    ScreenLoader,
    ModalInfo
    // GooglePayButton
  },
  data () {
    return {
      wasInBackground: false,
      paymentButtonText: null,
      deleteCardModalOpen: false,
      keyProductToDelete: null,
      totalValue: 0,
      paymentOptions: [
        {
          id: 1,
          name: 'Cartão',
          icon: {
            type: 'fas',
            name: 'credit-card'
          }
        },
        {
          id: 2,
          name: 'Pix',
          icon: {
            type: 'fab',
            name: 'pix'
          }
        }
      ],
      activePaymentOption: 1,
      listFields: ['Final', 'Nome', 'Validade', 'Bandeira'],
      selectedCard: null,
      selectedFlag: '',
      loadingQrCode: false,
      qrCodeText: '',
      pixTimeout: 0,
      pixPaymentInterval: null,
      error: false,
      openedPayment: false,
      isLoading: false,
      emailSent: false,
      isPixCheckInProgress: false,
      currentNit: null, // Armazena o NIT atual para uso no Pix
      pixExpirationDate: null, // Armazena a data de expiração do Pix
      pixCountdownIntervalId: null, // ID do intervalo de contagem regressiva
      pixPaymentTimeoutId: null, // ID do timeout para checagem do Pix
      handleVisibilityChange: null // Função para lidar com mudanças de visibilidade
    }
  },
  beforeUnmount () {
    clearInterval(this.pixPaymentInterval)
  },
  mounted () {
    this.totalValue = this.getCartTotalPrice()
    getUserCards()

    if (!this.getCart || !this.getCart.length) {
      const routeTo = this.isFullApp ? '/' : '/read-qrcode'
      Util.showErrorNotification({ title: 'Carrinho vazio ou expirado', text: 'Adicione produtos para continuar' })
      return this.$router.push(routeTo)
    }

    if (JSON.stringify(this.getCart) === this.getPix.cart) {
      this.activePaymentOption = 2 // Define Pix como opção ativa
      this.qrCodeText = this.getPix.qrCodeText
      this.pixTimeout = this.getPix.pixTimeout
      this.pixExpirationDate = new Date(Date.now() + this.pixTimeout)
      this.startPixCountdown()
      if (this.getPix.nit) {
        this.checkPixStatus(this.getPix.nit)
      }
    }

    const storedPixInfo = localStorage.getItem('pixPaymentInfo')
    if (storedPixInfo && !this.getPix?.nit) {
      const pixInfo = JSON.parse(storedPixInfo)
      this.activePaymentOption = 2 // Define Pix como opção ativa
      this.setPix(pixInfo)
      this.qrCodeText = pixInfo.qrCodeText || ''
      this.pixTimeout = pixInfo.pixTimeout || 0
      this.pixExpirationDate = new Date(Date.now() + this.pixTimeout)
      this.currentNit = pixInfo.nit || null
      if (this.currentNit) {
        this.startPixCountdown()
        this.checkPixStatus(this.currentNit)
      }
    }
  },
  computed: {
    ...mapGetters(['getCart', 'cardAdditionMenu', 'userCardList', 'pixRechargeInfo', 'newCardInfra', 'getCurrentEvent', 'getPix', 'isFullApp'])
  },
  methods: {
    ...mapActions(['showModalInfo', 'closeModalInfo', 'updateCurrentItemEdit', 'changeCardAdditionMenuVisibility', 'clearNewCardValues', 'setPixRechargeInfo', 'setPix']),
    formatMilliseconds (value) {
      // return Util.formatMilliseconds(value)
      return value > 0 ? Util.formatMilliseconds(value) : '0m 0s'
    },
    formatMoney (value) {
      return Util.formatMoney(value)
    },
    getCartTotalPrice: function () {
      return CartController.calculateTotalPrice()
    },
    isDisabledCheckout: function () {
      const { VUE_APP_DISABLED_CHECKOUT: disabled = 'NO' } = process.env
      return disabled.toUpperCase() === 'YES' || disabled.toUpperCase() === 'TRUE'
    },
    getExpirationAsDate: function (date) {
      let expirationDate = moment(date, 'MM/YY')
      if (expirationDate.isValid()) {
        return expirationDate.format('MM/YY')
      }
      expirationDate = moment(date)
      if (expirationDate.isValid()) {
        return expirationDate.format('MM/YY')
      }
    },
    getCardFlag: function (flag) {
      if (flag && flag.length > 2) {
        try {
          return require('@/assets/icons/cardflags/' + flag.toLocaleLowerCase() + '.svg')
        } catch (e) {
          return require('@/assets/icons/cardflags/generic-clean.svg')
        }
      }
      return ''
    },
    selectCard (card) {
      this.selectedCard = this.selectedCard === card ? null : card
    },
    addCard: async function () {
      this.isLoading = true
      const result = await registerNewCard()
      if (result && !result.error) {
        this.showModalInfo({ type: 'success', text: 'Cartão cadastrado com sucesso', open: true })
        this.clearNewCardValues()
        this.changeCardAdditionMenuVisibility()
      } else {
        this.changeCardAdditionMenuVisibility()
        Util.showErrorNotification({ title: 'Problemas ao cadastrar cartão', text: result?.message || 'Erro ao cadastrar cartão' })
      }
      this.isLoading = false
      document.body.style.overflow = 'auto'
    },
    copyPixCode: async function () {
      // tem que funcionar no mobile
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(this.qrCodeText)
        Util.showSuccessNotification({ title: 'Código copiado com sucesso', text: null })
      } else { // fallback para navegadores antigos e mobile
        this.$refs.pixCodeInput.select()
        document.execCommand('copy')
        Util.showSuccessNotification({ title: 'Código copiado com sucesso', text: null })
      }
    },
    handlePaymentOption: async function (option) {
      if (option.disabled) {
        return false
      }
      this.activePaymentOption = option.id
      this.paymentButtonText = null

      // se for cartão, limpa o cartão selecionado
      if (this.activePaymentOption === 1) {
        this.selectedCard = null
        return this.activePaymentOption
      }
      if (!this.qrCodeText) {
        this.paymentButtonText = 'Gerar QRCode de Pagamento'
      }
    },
    sendEmailConfirmation: async function () {
      try {
        const response = await sendEmailConfirmation()
        if (response && response.error) {
          this.emailSent = false
          Util.showWarningNotification({ title: 'E-mail de confirmação não enviado', text: response?.message })
        } else {
          this.emailSent = true
        }
      } catch (e) {
        Util.showErrorNotification({ title: 'Problemas ao enviar e-mail de confirmação', text: e?.response?.data?.message || e?.message })
      }
    },
    resetPixText: function () {
      this.qrCodeText = ''
      this.paymentButtonText = 'Gerar QRCode de Pagamento'
    },
    stopAndClearPixPolling: function () {
      if (this.pixPaymentInterval) {
        clearInterval(this.pixPaymentInterval)
        this.pixPaymentInterval = null
      }
      if (this.handleVisibilityChange) {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange)
        this.handleVisibilityChange = null
      }
      this.setPix({}) // Limpa o estado do Pix no Vuex
      this.isPixCheckInProgress = false // Libera a flag

      localStorage.removeItem('pixPaymentInfo') // Limpa o armazenamento local

      // libera o countdown se estiver ativo
      if (this.pixCountdownIntervalId) {
        clearInterval(this.pixCountdownIntervalId)
        this.pixCountdownIntervalId = null
      }

      if (this.pixPaymentTimeoutId) {
        clearTimeout(this.pixPaymentTimeoutId)
        this.pixPaymentTimeoutId = null
      }
    },
    startPixCountdown () {
      // Se já existir um intervalo de countdown, não cria outro
      if (this.pixCountdownIntervalId) return

      this.pixCountdownIntervalId = setInterval(() => {
        if (!this.pixExpirationDate) return

        const agora = new Date()
        const restante = this.pixExpirationDate.getTime() - agora.getTime()
        this.pixTimeout = restante

        // Atualiza estado no Vuex
        this.setPix({
          cart: this.getPix.cart,
          qrCodeText: this.qrCodeText,
          pixTimeout: this.pixTimeout,
          nit: this.currentNit
        })

        if (restante <= 0) {
          // Cancela o próprio interval para não repetir
          clearInterval(this.pixCountdownIntervalId)
          this.pixCountdownIntervalId = null

          // Faz uma última verificação do status do Pix antes de expirar
          getPixPaymentStatus(this.currentNit)
            .then(r => {
              if (r.data.status === 'CONFIRMED') {
                // Pagamento confirmado nos últimos segundos
                if (this.pixPaymentTimeoutId) {
                  clearTimeout(this.pixPaymentTimeoutId)
                  this.pixPaymentTimeoutId = null
                }
                document.removeEventListener('visibilitychange', this.handleVisibilityChange)
                CartController.clearCart()
                this.stopAndClearPixPolling()
                if (!this.isFullApp && !this.emailSent) {
                  this.emailSent = true
                  this.sendEmailConfirmation()
                }
                this.$router.push('/purchase-success')
              } else {
                // Não confirmado → expira o Pix
                console.log('Pix timeout reached (final check).')
                Util.showErrorNotification({
                  title: 'Tempo Esgotado',
                  text: 'O prazo para pagamento do Pix expirou.'
                })
                this.stopAndClearPixPolling()
                this.handlePaymentOption(this.paymentOptions[1])
                this.resetPixText()
              }
            })
            .catch(e => {
              // Em caso de erro na checagem final, considera expirado
              console.error('Erro na checagem final do Pix (countdown):', e)
              Util.showErrorNotification({
                title: 'Tempo Esgotado',
                text: 'O prazo para pagamento do Pix expirou.'
              })
              this.stopAndClearPixPolling()
              this.handlePaymentOption(this.paymentOptions[1])
              this.resetPixText()
            })
        }
      }, 1000)
    },
    checkPixStatus (nit) { // checa o status do pagamento pix em intervalos de 1 segundo
      // Garante que só haja uma checagem em curso
      if (this.isPixCheckInProgress) return
      this.isPixCheckInProgress = true
      this.currentNit = nit // armazena nit para usar no setPix

      const runCheck = () => {
        getPixPaymentStatus(nit).then(r => {
          // pagamento confirmado
          if (r.data.status === 'CONFIRMED') {
            clearInterval(this.pixPaymentInterval)
            document.removeEventListener('visibilitychange', this.handleVisibilityChange)
            CartController.clearCart()
            this.stopAndClearPixPolling() // Para tudo e limpa

            // email de confirmação
            if (!this.isFullApp && !this.emailSent) {
              this.emailSent = true
              this.sendEmailConfirmation()
            }

            this.$router.push('/purchase-success')
            return true
          } else if (r.data.status === 'DENIED') { // pagamento negado
            Util.showErrorNotification({ title: 'Problemas com o pagamento', text: r.data?.message || r?.message })
            this.showModalInfo({
              type: 'error',
              text: 'Pagamento negado. Tente novamente ou utilize outro meio de pagamento.',
              open: true
            })

            this.stopAndClearPixPolling() // Para tudo e limpa
            this.handlePaymentOption(this.paymentOptions[1])
            this.resetPixText()
            return false
          }

          // Agenda próxima checagem em 15s
          this.pixPaymentTimeoutId = setTimeout(() => {
            this.isPixCheckInProgress = false
            runCheck()
          }, 15000)
        }).catch(async e => {
          console.error('Erro ao checar status do Pix:', e)
          if (e.code === 'ERR_NETWORK') {
            // Em caso de erro de rede, libera flag e agenda nova checagem em 10s
            this.isPixCheckInProgress = false
            // Cancela eventual agendamento anterior
            if (this.pixPaymentTimeoutId) {
              clearTimeout(this.pixPaymentTimeoutId)
              this.pixPaymentTimeoutId = null
            }
            this.pixPaymentTimeoutId = setTimeout(() => {
              runCheck()
            }, 10000)
          } else {
            Util.showErrorNotification({ title: 'Problemas com o pagamento', text: e?.response?.data?.message || e?.message })
            this.stopAndClearPixPolling() // Para tudo e limpa
          }
        })
      }

      // Registra listener de visibilidade para checagem imediata ao voltar ao tab
      this.handleVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
          // Se voltar do segundo plano, faz checagem imediata
          if (this.pixPaymentTimeoutId) {
            clearTimeout(this.pixPaymentTimeoutId)
            this.pixPaymentTimeoutId = null
          }
          // Garante que só haja uma checagem de cada vez
          runCheck()
        }
      }
      document.addEventListener('visibilitychange', this.handleVisibilityChange)

      this.startPixCountdown() // Inicia contagem regressiva
      runCheck() // Inicia o primeiro check
    },
    stopPixInterval () {
      clearInterval(this.pixPaymentInterval)
      document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    },
    finishSale: async function (nsu, nit, CDTIPORECE, paymentType) { // finaliza a venda apos o pagamento com cartao, se for pix, chama a funcao de checar o status do pix
      if (!nsu) {
        Util.showErrorNotification({ title: 'Problemas com o pagamento', text: 'Erro ao finalizar pagamento' })
        if (paymentType === 'pix') {
          this.stopAndClearPixPolling() // Para tudo e limpa
          this.resetPixText() // Reseta o texto do QRCode e botão
        }
        return
      }
      if (!this.getCurrentEvent) {
        const response = await loadSingleEvent()
        if (!response || response.error) {
          this.showModalInfo({
            type: 'error',
            text: response?.message || 'Erro ao carregar evento. Verifique se o evento existe.',
            open: true
          })

          if (paymentType === 'pix') {
            this.stopAndClearPixPolling() // Para tudo e limpa
            this.resetPixText() // Reseta o texto do QRCode e botão
          }
          return
        }
      }
      try {
        const response = await doFinishSale({ nsu, nit, CDTIPORECE, cart: this.getCart, eventData: this.getCurrentEvent, paymentType })
        if (!response || response.error) {
          this.showModalInfo({
            type: 'error',
            text: response?.message || 'Erro ao finalizar pagamento',
            open: true
          })

          if (paymentType === 'pix') {
            this.stopAndClearPixPolling() // Para tudo e limpa
            this.resetPixText() // Reseta o texto do QRCode e botão
          }

          return
        }
      } catch (e) {
        this.showModalInfo({
          type: 'error',
          text: e?.response?.data?.message || e?.message || 'Erro ao finalizar pagamento',
          open: true
        })
        if (paymentType === 'pix') {
          this.stopAndClearPixPolling() // Para tudo e limpa
          this.resetPixText() // Reseta o texto do QRCode e botão
        }
        console.log(e)
        return
      }

      // manda email de confirmacao caso nao seja pix - app mini
      if (!this.isFullApp && paymentType !== 'pix') {
        this.sendEmailConfirmation()
      }

      // caso for pix, chama a funcao de checar o status do pix em intervalos
      if (paymentType !== 'pix') {
        CartController.clearCart()
        this.$router.push('/purchase-success')
      } else {
        this.emailSent = false
        this.checkPixStatus(nit)
      }
    },
    processPixPayment: async function () {
      // Gerar QRCode de pagamento
      if (this.paymentButtonText) {
        this.denied = false

        try {
          const response = await doPixPayment(this.totalValue)
          if (response && response.error === true) {
            Util.showErrorNotification({ title: 'Problemas com o pagamento', text: response?.message || 'Erro ao gerar QRCode' })
            this.isLoading = false
            return
          }

          this.paymentButtonText = null
          this.qrCodeText = response?.data?.qrCode
          this.pixTimeout = response?.data?.pixTimeout
          this.pixExpirationDate = new Date(Date.now() + this.pixTimeout)
          this.setPix({
            cart: JSON.stringify(this.getCart),
            qrCodeText: this.qrCodeText,
            pixTimeout: this.pixTimeout,
            nit: response?.data?.nit
          })

          // se o pagamento foi aberto, checa o status do pix
          await this.finishSale(response?.data?.nsu, response?.data?.nit, response?.data?.payment, 'pix')
        } catch (e) {
          Util.showErrorNotification({ title: 'Problemas com o pagamento', text: e?.response?.data?.message || e?.message })
          console.log(e)
        } finally {
          this.isLoading = false
        }
      } else if (this.activePaymentOption === 2 && !this.loadingQrCode && !this.error && this.qrCodeText) {
        this.copyPixCode()
        this.isLoading = false
      }
    },
    processCardPayment: async function () {
      // se for cartão, verifica se tem cartão selecionado e realiza o pagamento
      if (this.selectedCard) {
        const cardToken = this.selectedCard.identifier

        try {
          const response = await doCardTokenPayment(this.totalValue, cardToken)
          if (response && response.error) {
            // melhorar retorno com base no erro
            Util.showErrorNotification({ title: 'Problemas com o pagamento', text: response?.message })
          } else {
            await this.finishSale(response?.data?.nsu, response?.data?.nit, response?.data?.payment)
          }
        } catch (e) {
          Util.showErrorNotification({ title: 'Problemas com o pagamento', text: e?.response?.data?.message || e?.message })
          console.log(e)
        } finally {
          this.isLoading = false
        }
      } else {
        Util.showErrorNotification({ title: 'Selecione um cartão', text: 'Selecione um cartão para continuar' })
        this.isLoading = false
      }
    },
    handleConfirmation: async function () {
      this.isLoading = true
      if (this.activePaymentOption === 1) {
        // pagamento com cartão
        await this.processCardPayment()
      } else if (this.activePaymentOption === 2) {
        // pagamento com pix
        await this.processPixPayment()
      }
    },
    deleteCard: function (card) {
      this.showModalInfo(
        {
          type: 'defaultDialog',
          text: `Deseja deletar o cartão com final ${card.number}?`,
          open: true
        }
      )
      document.body.style.overflow = 'auto'
    },
    confirmDeleteCard: async function () {
      this.closeModalInfo()
      this.isLoading = true
      await deleteCreditCard(this.selectedCard)
      this.isLoading = false
    },
    // GOOGLE PAY
    handleGpayConfirmation: async function (paymentData) {
      if (!paymentData || !paymentData?.tokenizationData?.token || !paymentData?.info?.cardNetwork) {
        Util.showErrorNotification({ title: 'Problemas com o pagamento', text: 'Erro ao processar pagamento' })
        return
      }

      this.isLoading = true
      try {
        const response = await doGooglePayPayment(this.totalValue, paymentData)
        console.log(response)
        if (response && response.error) {
          Util.showErrorNotification({ title: 'Problemas com o pagamento', text: response?.message || 'Erro ao finalizar pagamento' })
        } else {
          await this.finishSale(response?.data?.nsu, response?.data?.nit, response?.data?.payment, 'wallet')
        }
      } catch (error) {
        console.error(error)
        Util.showErrorNotification({ title: 'Problemas com o pagamento', text: error?.message || 'Erro ao finalizar pagamento' })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="less">
.checkout-view {
  position: relative;
  display: block;
  padding: 65px 20px 170px 20px;
  &.isLoading {
    pointer-events: none;
  }

  .payment-container {
    margin-top: 10px;

    .payment-options {
      .payment-options-list {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        width: 100%;

        .payment-option {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          padding: 15px 20px;
          background: #3c3c3b05;
          font-size: 10px;
          font-weight: 600;

          .payment-option-icon {
            font-size: 20px;
          }

          .pix {
            color: #32BCAD;
          }

          .credit-card {
            color: #675DFF;
          }

          .payment-option-name {
            width: 80%;

            span {
              font-size: 1rem;
              color: #666;
            }
          }

          &.disabled {
            pointer-events: none;
            filter: grayscale(1);
          }

          &.active {
            &.isCard {
              background: #2D68C41A;
              border-top: 3px solid #675DFF;

              .payment-option-name {
                span {
                  color: #675DFF;
                }
              }
            }

            &.isPix {
              background: #2dc4991a;
              border-top: 3px solid #32BCAD;

              .payment-option-name {
                span {
                  color: #32BCAD;
                }
              }
            }
          }
        }
      }

      .credit-card {
        .cards-list {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-top: 30px;

          h1 {
            font-size: 16px;
            margin-bottom: 30px;
            font-weight: 500;
            align-self: baseline;
          }

          .list-fields {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            width: calc(100% - 30px);
            gap: 15px;
            text-align: center;
            margin-bottom: 10px;

            span {
              font-size: 14px;
              font-weight: 600;
            }
          }

          .card-item-wrapper {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 2px;
            border-radius: 10px;
          }

          .card-item {
            flex-grow: 1;
          }

          .delete-button {
            background-color: #ff4d4d;
            border: none;
            color: white;
            padding: 8px 12px;
            border-radius: 6px;
            cursor: pointer;
            margin-left: 10px;
            font-weight: bold;
          }

          .fade-slide-enter-active, .fade-slide-leave-active {
            transition: opacity 0.25s ease, transform 0.25s ease;
          }

          .fade-slide-enter-from {
            opacity: 0;
            transform: scale(0.8);
          }

          .fade-slide-enter-to {
            opacity: 1;
            transform: scale(1);
          }

          .fade-slide-leave-from {
            opacity: 1;
            transform: scale(1);
          }

          .fade-slide-leave-to {
            opacity: 0;
            transform: scale(0.8);
          }

          .card-item {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 15px;
            width: calc(100% - 20px);
            padding: 15px;
            border-radius: 10px;
            margin-bottom: 15px;
            background-color: rgba(0, 0, 0, 0.05);
            font-size: 16px;
            font-weight: 600;
            word-break: break-word;
            text-align: center;

            img {
              width: 60px;
              height: 40px;
              border-radius: 10px;
            }
            >div {
              display: block;
              margin: auto;
            }

            span {
              font-size: 14px;
              font-weight: 600;
            }

            &.selected {
              border: 2px solid var(--primaryColor);
              color: var(--primaryColor)
            }
          }

        }

        .not-found {
          margin-top: 30px;
          text-align: center;

          h1 {
            font-size: 16px;
            font-weight: 500;
          }
        }

        .add-card {
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 15px 0 70px 0;
          color: white;

          button {
            font-weight: 600;
            border: 1px solid var(--primaryColor);
            border-radius: 5px;
            background-color: #fff;
            padding: 0 10px;
            color: var(--primaryColor);
          }
        }

      }

      .pix-container {
        .loading {
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 100%;

          h2 {
            font-size: 20px;
            margin-top: 20px;
          }
        }

        .opened-payment,
        .error {
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 100%;
          padding: 0px 20px;
          margin-top: 40px;
          text-align: center;
          font-size: 18px;
        }

        .qrcode {
          display: flex;
          justify-content: center;
          margin: 0px 20px;
          flex-direction: column;

          .container {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 20px;
          }

          h2 {
            text-align: center;
            margin-top: 20px;
            font-size: 20px;
          }
        }

        .copy-pix {
          display: flex;
          flex-direction: column;
          align-items: center;

          input {
            padding: 10px;
            font-size: 16px;
            border-radius: 5px;
            border: 1px solid #636363;
          }

          button {
            margin-top: 15px;
            border: 1px solid var(--primaryColor);
            border-radius: 5px;
            background-color: #fff;
            padding: 10px 20px;
            color: var(--primaryColor);
            cursor: pointer;
          }
        }

        .finish-payment-warning {
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
  }

  .checkout {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    background: white;
    bottom: 0;
    width: -webkit-fill-available;
    left: 0;
    animation: upper-in 0.4s;
    padding: 10px 0 40px 0;
    filter: drop-shadow(2px 4px 6px black);

    .total-price {
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin: 15px;

      h2 {
        font-size: 1rem;
        margin: 0;
        padding-left: 20px;
        color: #666;
      }

      span {
        font-size: 1rem;
        font-weight: 600;
        padding-right: 20px;
      }
    }

    .custom-default-button {
      button {
        display: block;
        min-width: 300px !important;
        height: 55px !important;
        margin: 5px !important;
        border: none;
        background: var(--primaryColor);
        color: white;
      }
    }
  }
}
</style>
